import React, { useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";
import Chat from "../components/Chat";
import FileShare from "../components/FileShare";

const baseUrl = window.__RUNTIME_CONFIG__.REACT_APP_BASE_URL;
const socket = io(baseUrl);

export default function Student() {
  const videoRef = useRef();
  const pcRef = useRef(null);
  const answerSent = useRef(false);
  const [userName, setUserName] = useState("");
  const [files, setFiles] = useState([]);

  // Первый useEffect — для WebRTC
  useEffect(() => {
    let pc;
    const pendingCandidates = [];
    function createPeerConnection() {
      pc = new RTCPeerConnection({
        iceServers: [
          { urls: "stun:stun.l.google.com:19302" },
          {
            urls: "turn:openrelay.metered.ca:80",
            username: "openrelayproject",
            credential: "openrelayproject"
          }
        ]
      });
      pc.ontrack = (event) => {
        const [stream] = event.streams;
        console.log("Поток для видео:", stream);
        if (stream && videoRef.current) {
          videoRef.current.srcObject = stream;
        }
      };
      pc.onicecandidate = (event) => {
        if (event.candidate) {
          const type = event.candidate.candidate.match(/ typ ([a-z]+)/)?.[1];
          console.log("ICE candidate:", event.candidate);
          console.log("ICE candidate type:", type, "candidate string:", event.candidate.candidate);
          socket.emit("ice-candidate", event.candidate);
        }
      };
      pc.onconnectionstatechange = () => {
        console.log("Student connection state:", pc.connectionState);
      };
      return pc;
    }

    socket.on("ice-candidate", async (data) => {
      const candidate = data.candidate || data;
      if (
        !candidate ||
        !candidate.candidate ||
        candidate.sdpMid == null ||
        candidate.sdpMLineIndex == null
      )
        return;
      if (pc) {
        if (pc.remoteDescription && pc.remoteDescription.type) {
          try {
            await pc.addIceCandidate(new RTCIceCandidate(candidate));
          } catch (err) {
            console.error("Ошибка добавления ICE у студента:", err);
          }
        } else {
          pendingCandidates.push(candidate);
        }
      }
    });

    socket.on("offer", async (offer) => {
      if (pc) pc.close();
      pc = createPeerConnection();
      pcRef.current = pc;
      answerSent.current = false;
      try {
        console.log("Получен offer от лектора");
        await pc.setRemoteDescription(new RTCSessionDescription(offer));
        while (pendingCandidates.length) {
          const candidate = pendingCandidates.shift();
          if (
            !candidate ||
            !candidate.candidate ||
            candidate.sdpMid == null ||
            candidate.sdpMLineIndex == null
          )
            continue;
          try {
            await pc.addIceCandidate(new RTCIceCandidate(candidate));
          } catch (err) {
            console.error(
              "Ошибка добавления ICE у студента (отложенный):",
              err
            );
          }
        }
        const answer = await pc.createAnswer();
        await pc.setLocalDescription(answer);
        socket.emit("answer", { answer, to: offer.from });
        answerSent.current = true;
      } catch (err) {
        console.error("Ошибка при обработке offer у студента:", err);
      }
    });

    socket.emit("need-offer");

    return () => {
      if (pc) pc.close();
    };
  }, []);

  // Второй useEffect — для файлов
  useEffect(() => {
    fetch(`${baseUrl}/api/files`)
      .then((res) => res.json())
      .then(setFiles)
      .catch(() => {});

    socket.on("new-file", (file) => {
      setFiles((prev) => [...prev, file]);
    });
    return () => socket.off("new-file");
  }, []);

  return (
    <div style={{ minHeight: "100vh", background: "#f9f9f9" }}>
      <h1
        style={{
          textAlign: "center",
          fontFamily: "Arial",
          margin: 0,
          padding: 24,
          fontWeight: 700,
          fontSize: 32,
          color: "#222",
        }}
      >
        Студент
      </h1>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: 32,
          maxWidth: 1400,
          margin: "0 auto",
          padding: "0 24px",
        }}
      >
        <div
          style={{
            flex: 2,
            background: "#000",
            borderRadius: 12,
            boxShadow: "0 2px 16px rgba(0,0,0,0.12)",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: 480,
          }}
        >
          <video
            ref={videoRef}
            autoPlay
            playsInline
            muted={false}
            controls={true}
            style={{
              width: "100%",
              height: "auto",
              maxHeight: 600,
              backgroundColor: "black",
              borderRadius: 0,
            }}
          />
        </div>
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: 24,
            maxHeight: 600,
            minWidth: 350,
            background: "#fff",
            borderRadius: 12,
            boxShadow: "0 2px 16px rgba(0,0,0,0.10)",
            padding: 20,
            overflowY: "auto",
          }}
        >
          <Chat userName={userName} setUserName={setUserName} />
          <FileShare isLecturer={false} />
        </div>
      </div>
    </div>
  );
}
